import {userConstants} from '../_constants';

export function turnoverStatistics(state = {}, action) {
  switch (action.type) {
    case userConstants.TURNOVER_STATISTICS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userConstants.TURNOVER_STATISTICS_SUCCESS:
      return {
        ...state,
        ...action.data,
        loading: false,
      };
    case userConstants.TURNOVER_STATISTICS_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}